import Vue from 'vue'
import router from '@/router/index'
import http from "@/api/fetch"
import api from "@/api/api"
import apiId from "@/api/apiId"

export default {
  install(Vue, options) {
    Vue.prototype.$http = http //axios全局方法
    Vue.prototype.$api = api //api地址全局方法
    Vue.prototype.$apiId = apiId; //请求id
    // 路由跳转全局方法
    Vue.prototype.routerLink = function() {
      let params = {}
      let path = arguments[0] ? arguments[0] : null;
      // params['id'] = arguments[1] ? arguments[1] : 0
      let obj = arguments[1] ? arguments[1] : null
      if (obj != null) {
        if (typeof obj == "object") {
          for (let key in obj) {
            params[key] = obj[key]
          }
        } else {
          throw new Error("路由链接函数第二个参数只支持object类型")
        }
      }
      router.push({
        name: path,
        params: params
      })
    }
    // get请求全局方法
    Vue.prototype.getAjax = function(url, params, succFun, errFun) {
      this.$http
        .get(url, {
          params: params
        })
        .then(res => {
          succFun(res);
        })
        .catch(err => {
          setTimeout(function() {
            errFun(err);
          }, 500)
        })
    }
    // post请求全局方法
    Vue.prototype.postAjax = function(url, params, succFun, errFun) {
      this.$http
        .post(url, params)
        .then(res => {
          succFun(res);
        })
        .catch(err => {
          setTimeout(function() {
            errFun(err);
          }, 500)
        })
    }
    //成功全局方法
    Vue.prototype.successMessage = function(value) {
      this.$message({
        showClose: true,
        message: value,
        type: 'success',
        duration: 1000
      })
    }
	let messageInstance = null;
    // 错误全局方法
    Vue.prototype.errorMessage = function(value) {
      if (messageInstance) {
        messageInstance.close();
      }
      messageInstance = this.$message({
        showClose: true,
        message: value,
        type: 'error',
        duration: 2500
      })
    }
    // 秒转时间
    Vue.prototype.formatSeconds = function(value) {
      value = parseInt(value);
      var time;
      var hour;
      var min;
      var sec;
      var day;
      if (value > -1) {
        hour = Math.floor(value / 3600);
        min = Math.floor(value / 60) % 60;
        sec = value % 60;
        day = parseInt(hour / 24);
        if (day > 0) {
          hour = hour - 24 * day;
          time = day + "day " + hour + ":";
        } else time = hour + ":";
        if (min < 10) {
          time += "0";
        }
        time += min + ":";
        if (sec < 10) {
          time += "0";
        }
        time += sec;
      }
      return time;
    }
    // 重置全局方法
    Vue.prototype.$reset = function() {
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/untils/global.js